import * as contentStyles from '../../styles/content.module.css'
import Link from 'next/link'
import NoSSR from 'react-no-ssr'
import ContentPanel from 'components/ContentPanel'

const SupportView = () => <div className={contentStyles.contentView}>
  <div className={contentStyles.contentTitleRow}>
    <h1>Support</h1>
    {/* <div className={contentStyles.contentTitlePhoto}><img alt='Picture of Support?' /></div> */}
  </div>
  <br />
  <ContentPanel>
    <h2>Report a bug or suggest an improvement</h2>
    <p>Head on over to <Link href='/feedback'><a>our Feedback page</a></Link></p>
  </ContentPanel>
  <br />
  <NoSSR>
    <ContentPanel>
      <h2>Other support requests</h2>
      <p>You can email Matt, the founder of CardHero, at <strong>matt@<span className={contentStyles.addrBit}>welcometo</span>thecardhero.com</strong></p>
    </ContentPanel>
  </NoSSR>
</div>

export default SupportView
